import React from "react";
import { Link } from "react-router-dom";

const GrievancePolicy = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero */}
      <div
        className="inner-page-hero"
        style={{ backgroundImage: "url(/assets/images/background/bg3.png)" }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>Grievance Redressal</h2>
          </div>
          <ul className="bradcrumb">
            <li><a href="/">Home</a></li>
            <li><Link to="#">Grievance Redressal Policy</Link></li>
          </ul>
        </div>
      </div>

      {/* Main Section */}
      <section className="privacy-section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-12">
              <div className="privacy-content-card">

                {/* Header */}
                <div className="mb-5 text-center">
                  <span className="heading-subtitle wow fadeInUp animated">
                    ⚖️ Grievance Redressal
                  </span>

                  <h2 className="wow fadeInUp animated">
                    Wall Street Finz — Grievance Redressal Policy
                  </h2>

                  <div className="meta-info-box">
                    <p><strong>Effective Date:</strong> Immediately upon publication</p>
                    <p><strong>Compliance:</strong> RBI Internal Ombudsman Directions 2023 | RBI Fair Practices Code</p>
                  </div>

                  <p className="intro-text mt-4">
                    Wall Street Finz is committed to providing a transparent,
                    efficient, and accessible grievance redressal mechanism for all
                    customers. This policy outlines our structured escalation
                    framework, resolution timelines, and complaint handling
                    procedures in compliance with regulatory requirements.
                  </p>
                </div>

                <hr className="divider" />

                {/* 1 How to Lodge Complaint */}
                <div className="policy-block">
                  <h3>1. How to Lodge a Complaint</h3>

                  <p>Choose any of these channels to register your grievance:</p>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Email Complaint</h4>
                      <p>
                        <a href="mailto:info@wallstreetfinz.com">
                          info@wallstreetfinz.com
                        </a>
                      </p>
                      <ul>
                        <li>Preferred for detailed complaints with attachments</li>
                        <li>24-hour acknowledgment</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Phone Support</h4>
                      <p>+91-9911998997</p>
                      <ul>
                        <li>Direct conversation with grievance team</li>
                        <li>Mon–Sat, 9:30 AM – 6:30 PM</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Written Complaint</h4>
                      <ul>
                        <li>Grievance Redressal Officer</li>
                        <li>Registered Office Address</li>
                        <li>Include reference number</li>
                      </ul>
                    </div>

                  </div>

                  <div className="alert-box warning mt-3">
                    Include in your complaint: Application/Loan reference number,
                    registered mobile number, clear description of issue, and
                    supporting documents if any.
                  </div>
                </div>

                {/* 2 Resolution Timeline */}
                <div className="policy-block">
                  <h3>2. Resolution Timeline & Escalation</h3>

                  <p>Structured escalation path with defined timelines:</p>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Level 1: Customer Support</h4>
                      <p>Initial complaint handling by front-line team.</p>
                      <p className="small text-muted">1 – 7 Days</p>
                      <p>85% complaints resolved</p>
                    </div>

                    <div className="info-card">
                      <h4>Level 2: Grievance Officer</h4>
                      <p>Escalated review by Grievance Redressal Officer.</p>
                      <p className="small text-muted">8 – 15 Days</p>
                      <p>Additional 10% resolved</p>
                    </div>

                    <div className="info-card">
                      <h4>Level 3: Internal Ombudsman</h4>
                      <p>Independent review for unresolved complaints.</p>
                      <p className="small text-muted">16 – 30 Days</p>
                      <p>Final 5% resolved</p>
                    </div>

                    <div className="info-card">
                      <h4>External: RBI Ombudsman</h4>
                      <p>
                        If unresolved after 30 days, customers may approach the
                        RBI Integrated Ombudsman Scheme.
                      </p>
                    </div>

                  </div>
                </div>

                {/* 3 Types of Complaints */}
                <div className="policy-block">
                  <h3>3. Types of Complaints We Address</h3>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Urgent Complaints</h4>
                      <ul>
                        <li>Unauthorized transactions</li>
                        <li>Fraudulent activities</li>
                        <li>Coercive recovery practices</li>
                        <li>Data privacy breaches</li>
                      </ul>
                      <p className="small text-muted">Resolution within 24 hours</p>
                    </div>

                    <div className="info-card">
                      <h4>Standard Complaints</h4>
                      <ul>
                        <li>Interest rate disputes</li>
                        <li>Documentation issues</li>
                        <li>Processing delays</li>
                        <li>Service quality concerns</li>
                      </ul>
                      <p className="small text-muted">Resolution within 7 days</p>
                    </div>

                    <div className="info-card">
                      <h4>Service Requests</h4>
                      <ul>
                        <li>Document requests</li>
                        <li>Account updates</li>
                        <li>Status inquiries</li>
                        <li>General information</li>
                      </ul>
                    </div>

                  </div>
                </div>

                {/* 4 Complaint Tracking */}
                <div className="policy-block">
                  <h3>4. Complaint Tracking & Follow-up</h3>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Mobile App</h4>
                      <p>Track status in the "My Complaints" section.</p>
                    </div>

                    <div className="info-card">
                      <h4>Customer Portal</h4>
                      <p>Login using reference number for updates.</p>
                    </div>

                    <div className="info-card">
                      <h4>Email Updates</h4>
                      <p>Automatic notifications via Email & SMS.</p>
                    </div>

                    <div className="info-card">
                      <h4>Call Support</h4>
                      <p>Quote reference number for updates.</p>
                    </div>

                  </div>
                </div>

                {/* 5 Exclusions */}
                <div className="policy-block">
                  <h3>5. Exclusions & Limitations</h3>

                  <ul className="check-list">
                    <li>Complaints already under court or consumer forum proceedings</li>
                    <li>Corporate fraud cases under police or regulatory investigation</li>
                    <li>Purely commercial decisions like loan approval or rejection</li>
                    <li>Internal employee grievances or HR issues</li>
                  </ul>
                </div>

                {/* 6 Policy Governance */}
                <div className="policy-block">
                  <h3>6. Policy Governance & Review</h3>

                  <ul className="check-list">
                    <li>Quarterly review by Compliance Committee</li>
                    <li>Half-yearly reporting to RBI as per guidelines</li>
                    <li>Annual approval by Board of Directors</li>
                    <li>Customer feedback incorporated for improvements</li>
                  </ul>
                </div>

                {/* Contact */}
                <div className="contact-block">
                  <h3>Contact Us</h3>

                  <p>
                    For questions, concerns, or requests related to grievances
                    or privacy:
                  </p>

                  <div className="contact-details">
                    <div className="contact-row">
                      <i className="flaticon-email"></i>
                      <a href="mailto:info@wallstreetfinz.com">
                        info@wallstreetfinz.com
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default GrievancePolicy;